module.exports = __webpack_public_path__ + "img/gartenzaun.a894dd3b.jpg";